import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import Lottie from "lottie-react";

import shareIcon from "../../../assets/images/share.png";
import closeIcon from "../../../assets/images/close.png";
import LottieAnimation from "../../../assets/json/sezione-04-popup-03-01-en.json";
import arrowIconWhite from "../../../assets/images/arrowIconWhite.png";

export default function Sezione4Approfondimento({ isOpen, onClose }) {
  const overlayRef = useRef(null);

  // ESC + blocco scroll quando il popup è aperto
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const onShare = (popupId) => {
    const url = new URL(window.location.href);
    url.searchParams.set("popup", popupId);

    if (navigator.share) {
      navigator
        .share({ title: "Commitment in favour of people", url: url.toString() })
        .catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url.toString()).catch(() => {});
    }
  };

  return createPortal(
    <div
      ref={overlayRef}
      className="fixed inset-0 z-[1001] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-3 md:p-6"
      onMouseDown={(e) => {
        if (e.target === overlayRef.current) onClose?.();
      }}
      role="dialog"
      aria-modal="true"
      aria-label="Commitment in favour of people"      
    >
      <div
        className="
          relative w-full md:w-[1280px] bg-white p-8
          max-h-[90vh] overflow-y-auto overscroll-contain
        "
        style={{ background: "linear-gradient(135deg,#F1F7FD 0%,#E7F1FA 100%)" }}
        onMouseDown={(e) => e.stopPropagation()} // evita chiusure accidentali
        onClick={(e) => e.stopPropagation()}
      >
        {/* Azioni in alto */}
        <div className="sticky top-3 z-10 flex items-center gap-2 justify-end pr-3">
          <button
            type="button"
            onClick={() => onShare("Sezione4Approfondimento")}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Condividi"
            aria-label="Condividi"
          >
            <img src={shareIcon} alt="" className="h-4 w-4" />
          </button>
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); onClose?.(); }}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Chiudi"
            aria-label="Chiudi"
          >
            <img src={closeIcon} alt="Chiudi" className="h-4 w-4" />
          </button>
        </div>

        {/* Contenuto */}
        <div className="py-8">
          <div className="max-w-[1080px] mx-auto">
            <Lottie
              animationData={LottieAnimation}
              loop={false}
              autoplay
              className="w-full h-auto"
            />
          </div>
        </div>

        {/* CTA finale opzionale */}
        <div className="mt-8">
          <a href="https://www.realegroup.eu/groupshare/0/EN/ListaReportsAndAccounts/64/Reale%20Group_Integrated%20Consolidated%20Financial%20Statement%202025.pdf#page=198" target="_blank">
          <button
            type="button"
            className="bt-secondary2"
          >
            <img src={arrowIconWhite} alt="Arrow" className="inline-block mr-2 w-[20px] h-[20px]" />
            Consult the Report - chapter 3 • par. 3.8.4
          </button>
          </a>
        </div>
        
      </div>
    </div>,
    document.body
  );
}
